import * as React from "react";
import {
  List, Datagrid, TextField, NumberField, useListContext,
} from "react-admin";
import { Alert } from "@mui/material";
import { ProReferenceInput } from "../../components/RelationAutocomplete";
import { FrDateField } from "../../components/FrDateField";
import { UserRefField } from "../../components/ui";

// GET /api/v1/bookings/awaiting-review?proId=… : RDV terminés (DONE) que le
// pro n'a pas encore évalués. proId est obligatoire côté backend
// (cf. resourceMap « awaiting-review », requiredFilters). Lignes = BookingDTO.
const filters = [
  <ProReferenceInput key="proId" source="proId" label="Professionnel" alwaysOn />,
];

const ProHint = () => {
  const { filterValues } = useListContext();
  if (filterValues?.proId) return null;
  return (
    <Alert severity="info" sx={{ m: 2 }}>
      Sélectionnez un professionnel pour afficher ses rendez-vous en attente de review.
    </Alert>
  );
};

export default {
  list: () => (
    <List filters={filters} empty={false} sort={{ field: "createdDate", order: "DESC" }}
      resource="awaiting-review" title="Rendez-vous en attente de review">
      <ProHint />
      <Datagrid rowClick={(id) => `/bookings/${encodeURIComponent(id)}/show`}
        bulkActionButtons={false}>
        <FrDateField source="slot.startTime" label="Date du RDV" showTime sortable={false} />
        <TextField source="firstNamePatient" label="Prénom patient" />
        <TextField source="lastNamePatient" label="Nom patient" />
        <UserRefField source="patientId" label="Patient" />
        <TextField source="nameSpeciality" label="Spécialité" />
        <TextField source="status" label="Statut" />
        <NumberField locales="fr-FR" source="price" label="Prix" options={{ style: "currency", currency: "EUR" }} />
      </Datagrid>
    </List>
  ),
};
